module.exports = __webpack_public_path__ + "static/pods-background-d58862431a0fe67d0332b098472073e7.png";